module.exports = __webpack_public_path__ + "static/img/user-7.90916cf4.jpg";